import { combineReducers } from 'redux'

import auth from './auth.reducer'
import dashboard from './dashboard.reducer'
import profile from './profile.reducer'
import detections from './detections.reducer'
import attributes from './attributes.reducer'
import exportqueue from './exportqueue.reducer'
import inspections from './inspections.reducer'
import upload from './upload.reducer'
import restores from './restores.reducer'

const rootReducer = combineReducers({
  auth,
  dashboard,
  profile,
  detections,
  attributes,
  exportqueue,
  inspections,
  upload,
  restores
})

export default rootReducer
